import { Button, Stack, Typography } from "@mui/material";
import * as buddyApi from "buddy/buddyDutyApi";
import { useAuthContext } from "context/GameAuthContext";
import { FeatureConfig } from "feature-configs/featureConfigApi";
import { isFeatureEnabled } from "feature-configs/featureConfigUtils";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useIntl } from "react-intl";
import { Navigate, useNavigate } from "react-router-dom";

type Props = {};

const BuddyDutyInvitation = (props: Props) => {
	const [loading, setLoading] = useState(false);
	const intl = useIntl();
	const { user } = useAuthContext();
	const { enqueueSnackbar } = useSnackbar();
	const navigation = useNavigate();

	const handleAccept = async () => {
		if (!user) return;
		setLoading(true);
		try {
			await buddyApi.acceptBuddyDuty(user.id);
			enqueueSnackbar(intl.formatMessage({ id: "USER-PROFILE.buddy.invitation.accepted" }), {
				variant: "success",
			});
			setLoading(false);
			navigation("/buddy/user-questionnaire");
		} catch (err) {
			enqueueSnackbar(intl.formatMessage({ id: "USER-PROFILE.buddy.invitation.error" }), { variant: "error" });
			setLoading(false);
		}
	};

	const handleReject = async () => {
		if (!user) return;
		setLoading(true);
		try {
			await buddyApi.rejectBuddyDuty(user.id);
			enqueueSnackbar(intl.formatMessage({ id: "USER-PROFILE.buddy.invitation.rejected" }), {
				variant: "success",
			});
			setLoading(false);
			// Navigate to user dashboard using window.location.href to repopulate the user data in the context from the local storage
			window.location.href = "/user-dashboard";
		} catch (err) {
			enqueueSnackbar(intl.formatMessage({ id: "USER-PROFILE.buddy.invitation.error" }), { variant: "error" });
			setLoading(false);
		}
	};

	if (!isFeatureEnabled(FeatureConfig.buddy)) {
		return <Navigate to="/user-dashboard" />;
	}

	return (
		<Stack gap={10} minHeight={"100vh"} justifyContent={"center"} alignItems={"center"}>
			<Stack gap={5} width={542} justifyContent={"center"} alignItems={"center"}>
				<Typography
					textAlign="center"
					variant="h4"
					style={{
						fontSize: "30px",
						fontStyle: "normal",
						fontWeight: 700,
					}}
				>
					{intl.formatMessage({
						id: "USER-PROFILE.buddy.invitation.title",
						defaultMessage: "Buddy Duty Invitation",
					})}
				</Typography>
				<img
					src={require("../assets/buddy-invitation.png").default}
					alt="Buddy Invitation"
					style={{ width: "100%", maxWidth: 176 }}
				/>
				<Typography textAlign="center" variant="body1">
					{intl.formatMessage(
						{
							id: "USER-PROFILE.buddy.invitation.text",
							defaultMessage:
								"Hi {name}, you've been invited by admin to become a buddy. If you're interested, please accept by clicking the 'Yes' button below.",
						},
						{ name: user?.name },
					)}
				</Typography>
				<Stack direction="column" gap={2}>
					<Button
						disabled={loading}
						variant="contained"
						onClick={handleAccept}
						style={{
							borderRadius: "40px",
							fontWeight: 700,
							minWidth: 270,
							textTransform: "capitalize",
						}}
					>
						{intl.formatMessage({
							id: "USER-PROFILE.buddy.invitation.yes",
						})}
					</Button>
					<Button
						disabled={loading}
						onClick={handleReject}
						style={{
							textTransform: "capitalize",
						}}
					>
						{intl.formatMessage({
							id: "USER-PROFILE.buddy.invitation.no",
						})}
					</Button>
				</Stack>
			</Stack>
		</Stack>
	);
};

export default BuddyDutyInvitation;
